import {ActionFunctionArgs, Form, redirect} from "react-router-dom";
import toast from "react-hot-toast";
import IndeterminateCheckbox from "../../components/inputs/IndeterminantCheckbox";
import {Input} from "../../components/inputs/Input";
import {FormLayout} from "../../layout/FormLayout";
import {createApolloClient} from "../../providers/ApolloClientFactory";
import {CREATE_IMAGE_LIBRARY} from "./mutations";
import {useState} from "react";
import {userStore} from "../../store/user";
import {
    organizationStore,
    useOrganizationStore,
} from "../../store/organization";
import CompactThumbUploader from "../../components/CompactThumbUploader";
import CustomSelect from "../../components/customSelect";

const client = createApolloClient();
const {getState} = userStore;
const {getState: getOrganizationStore} = organizationStore;

export const ImageLibraryCreateAction = async ({
                                                   params,
                                                   request,
                                               }: ActionFunctionArgs) => {
    const body = await request.formData();
    const user = getState().user;
    let input;
    let bodyData: any = Object.fromEntries(body);
    bodyData = {
        ...bodyData,
    };
    input = {
        ...bodyData,
        last_updated_by: user?.id,
    };

    try {
        const {data} = await client.mutate({
            mutation: CREATE_IMAGE_LIBRARY,
            variables: {
                input,
            },
        });

        toast.success("Image Library Item Created");

        return redirect(`/image-library/list`);
    } catch (error: any) {
        const errorType = error?.graphQLErrors?.[0]?.extensions?.code;
        const message = error?.graphQLErrors?.[0]?.message;
        if (errorType === "constraint-violation") {
            toast.error(message);
        } else {
            toast.error("Failed to create Image Library Item" + error);
        }
        return redirect("/image-library/create");
    }
};

export const ImageLibraryCreate = () => {
    const organizations = useOrganizationStore((state) => state.organizations);
    const organizationId = getOrganizationStore().organizationId;
    const user = getState().user;
    const admin = user?.role?.name === "admin"
    const [thumbBase64, setThumbBase64] = useState<string>("");

    const handleThumbReady = async (blob: Blob) => {
        const dataUrl = await blobToDataURL(blob);
        console.log("Data URL" + dataUrl)
        const rawBase64 = dataUrlToRawBase64(dataUrl);
        console.log("Base64" + rawBase64)
        setThumbBase64(rawBase64);
    };

    async function blobToDataURL(blob: Blob): Promise<string> {
        return await new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(String(fr.result));
            fr.onerror = reject;
            fr.readAsDataURL(blob);
        })
    }

    function dataUrlToRawBase64(dataUrl: string): string {
        const [, raw = ""] = dataUrl.split(",", 2);
        return raw;
    }

    function handleClearImage() {
        setThumbBase64("");
    }


    return (
        <Form
            method="post"
            action={`/image-library/create`}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
        >
            <FormLayout>
                <div className="col-span-3">
                    <Input
                        label="Display Name"
                        name="display_name"
                    />
                </div>
                <div className="col-span-1">
                    <IndeterminateCheckbox
                        label="Is Active?"
                        name="is_active"
                        defaultChecked={true}
                    />
                </div>
                {admin && (
                    <div className="col-span-6">
                        <CustomSelect
                            title="Organization"
                            name="organization_id"
                            required
                            defaultValue={organizationId}
                            options={organizations.map((org) => ({
                                label: org.name,
                                value: org.id,
                            }))}
                        />
                    </div>
                )}
                <div className="col-span-6">
                    <Input
                        label="Caption"
                        name="caption"
                    />
                </div>
                <div className="col-span-6">
                    <h3 className="text-lg font-semibold m-0">Upload Image
                        <CompactThumbUploader onReady={handleThumbReady} allowLibraryAdd={false}/></h3>
                </div>
                <div className="col-span-6">
                    {thumbBase64 && (
                        <div className="relative w-[125px] h-[125px]">
                            <img
                                src={`data:image/webp;base64,${thumbBase64}`}
                                width="100%"
                                height="100%"
                                alt="thumb"
                                className="rounded border border-slate-200 object-cover"
                            />
                            <button
                                type="button"
                                onClick={handleClearImage}
                                aria-label="Remove image"
                                title="Remove image"
                                className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#f04345] text-white
                            flex items-center justify-center shadow ring-1 ring-white/60 hover:opacity-90
                            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f04345]"
                            >
                                X
                            </button>
                        </div>
                    )}
                </div>
                {!admin && (
                <input
                    type="hidden"
                    value={organizationId || 0}
                    name="organization_id"
                />
                )}
                <input
                    type="hidden"
                    value={thumbBase64}
                    name="image_base64"/>
            </FormLayout>
        </Form>
    );
};
